var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tishi-Tips2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Defi",
    transform: "translate(-887.000000, -441.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD",
    transform: "translate(225.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tishi-Tips2",
    transform: "translate(662.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C6.05585366,14 5.13902439,13.8156098 4.27512195,13.4502439 C3.44195122,13.0968293 2.69243902,12.5931707 2.0504878,11.9495122 C1.40853659,11.307561 0.903170732,10.5580488 0.549756098,9.72487805 C0.184390244,8.86097561 0,7.94414634 0,7 C0,6.05585366 0.184390244,5.13902439 0.549756098,4.27512195 C0.903170732,3.44195122 1.40682927,2.69243902 2.0504878,2.0504878 C2.69243902,1.40853659 3.44195122,0.903170732 4.27512195,0.549756098 C5.13902439,0.184390244 6.05585366,0 7,0 C7.94414634,0 8.86097561,0.184390244 9.72487805,0.549756098 C10.5580488,0.903170732 11.307561,1.40682927 11.9495122,2.0504878 C12.5914634,2.69243902 13.0968293,3.44195122 13.4502439,4.27512195 C13.8156098,5.13902439 14,6.05585366 14,7 C14,7.94414634 13.8156098,8.86097561 13.4502439,9.72487805 C13.0968293,10.5580488 12.5931707,11.307561 11.9495122,11.9495122 C11.307561,12.5914634 10.5580488,13.0968293 9.72487805,13.4502439 C8.86097561,13.8156098 7.94414634,14 7,14 Z M7,1.19512195 C3.79878049,1.19512195 1.19512195,3.79878049 1.19512195,7 C1.19512195,10.2012195 3.79878049,12.804878 7,12.804878 C10.2012195,12.804878 12.804878,10.2012195 12.804878,7 C12.804878,3.79878049 10.2012195,1.19512195 7,1.19512195 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8.2002439 C6.6704878,8.2002439 6.40243902,7.93219512 6.40243902,7.60268293 L6.40243902,3.83634146 C6.40243902,3.50682927 6.6704878,3.23878049 7,3.23878049 C7.3295122,3.23878049 7.59756098,3.50682927 7.59756098,3.83634146 L7.59756098,7.60268293 C7.59756098,7.93219512 7.3295122,8.2002439 7,8.2002439 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56047767,9.98190697 C6.71747339,10.1389222 6.94631308,10.2002483 7.16078705,10.1427822 C7.37526103,10.0853162 7.54278198,9.91778939 7.60024054,9.70331341 C7.6576991,9.48883744 7.59636499,9.25999989 7.43934431,9.10300964 C7.28234859,8.94599444 7.05350889,8.88466832 6.83903492,8.94213437 C6.62456095,8.99960042 6.45704,9.16712722 6.39958144,9.3816032 C6.34212287,9.59607917 6.40345699,9.82491672 6.56047767,9.98190697 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.6fbf9a6b09840d96e480685e13a8ad1d.svg";
export { ForwardRef as ReactComponent };